import React from "react";
import PropTypes from "prop-types";
import { Box, Button } from "@mui/material";
import { bondTabs } from "../hooks/useApproveBonds";

export default function ApproveBondsLoadMoreSection({
  hasMore,
  tabIndex,
  fetchBonds,
  start,
  end,
}) {
  if (!(hasMore && tabIndex !== 0 && tabIndex !== 3 && bondTabs[tabIndex] !== "Data Corrections")) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
      <Button variant="contained" onClick={() => fetchBonds(start, end)}>
        Load More
      </Button>
    </Box>
  );
}

ApproveBondsLoadMoreSection.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  tabIndex: PropTypes.number.isRequired,
  fetchBonds: PropTypes.func.isRequired,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
};
